import type { Ref } from 'vue'

type TooltipControlsEmit = (
  event: 'remove:tooltip' | 'update:tooltip',
  ...args: any[]
) => void

export const useToolTipControls = (
  emit: TooltipControlsEmit,
  tooltip: Ref<ToolTip | null>
) => {
  const updateToolTip = (
    event: Event,
    id: string,
    right: boolean,
    locked: boolean = false,
    target: string | null = null
  ) => {
    if (tooltip.value?.locked) return

    const rect = (event.target as HTMLElement).getBoundingClientRect()
    emit('update:tooltip', {
      id: id,
      locked: locked,
      position: {
        x: right ? rect.x + rect.width : rect.x,
        y: rect.y + window.scrollY,
      },
      right: right,
      target: target,
    })
  }

  const removeToolTip = () => {
    if (tooltip.value && !tooltip.value.locked)
      emit('remove:tooltip', tooltip.value)
  }

  return { updateToolTip, removeToolTip }
}
